import BlockIntegrations from './integrations'

export default BlockIntegrations
